'use strict';

var chunk3A5DQBXA_js = require('./chunk-3A5DQBXA.js');
var chunkWVST6R4U_js = require('./chunk-WVST6R4U.js');
var chunk3WOKHVFK_js = require('./chunk-3WOKHVFK.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var t = require('react');
var l = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var t__default = /*#__PURE__*/_interopDefault(t);
var l__default = /*#__PURE__*/_interopDefault(l);

var L=l__default.default.div`
  margin-bottom: 0;
  padding: 20px 72px 64px;
  &.drivingWithBottom {
    margin-bottom: 74px;
  }
  &.noBottomNav {
    margin-bottom: 0;
  }
  &.bottomNavWithStickyCta {
    margin-bottom: 74px;
  }

  & h4 {
    margin-bottom: 8px;
    color: #717272;
    font-size: 32px;
    font-weight: 700;
    line-height: 38px;
  }

  & p {
    margin-bottom: 0;
    color: #0F0F10;
    font-size: 12px;
    line-height: 18px;
  }

  @media screen and (max-width: 767px) {
    padding: 24px 20px 26px;
    width: 100%;

    & h4 {
        margin-bottom: 16px;
        font-size: 28px;
        line-height: 34px;
    }
  }
`,N=l__default.default.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`,z=l__default.default.div`
  flex: 1;
`,D=l__default.default.div`
  width: 136px;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;

    & > img {
      width: 100%;
    }
`,T=l__default.default.video`
  width: 100%;
  height: 219px;
  object-fit: cover;
`,A=({data:o,renderSections:e})=>{let{sorting_order:p}=o;return t__default.default.createElement(t__default.default.Fragment,null,p.map(s=>e(s,o[s])))},H=({routeName:o,drivingWithBottomRoutes:e=[],showBottomNavbar:p,bottomSticky:s,driver:r,videoUrl:n})=>{let{tokens:d}=chunkHUKGHOBJ_js.b();return t__default.default.createElement("div",null,n?t__default.default.createElement(T,{loop:!0,muted:!0,preload:"auto",autoPlay:!0},t__default.default.createElement("source",{src:n,type:"video/mp4"}),t__default.default.createElement("track",{kind:"captions",src:n}),"Your browser does not support the video tag."):t__default.default.createElement(L,{className:`${e.includes(o)?"drivingWithBottom":""} ${p?"":"noBottomNav"} ${s?"bottomNavWithStickyCta":""}`},t__default.default.createElement(N,null,t__default.default.createElement(z,null,t__default.default.createElement(chunkWVST6R4U_js.a,{as:"h4",size:"300",color:d.text_default_text_primary,fontWeight:"bold"},"Better drives,",t__default.default.createElement("br",null),"better lives")),t__default.default.createElement(D,null,t__default.default.createElement("img",{src:r,alt:"Driving happier car"})))))},$=l__default.default.footer`
   margin-bottom: 56px;
  padding: 24px 20px;
  background: #f5f5f5;
`,j=l__default.default.div`
  display: flex;
    flex-direction: column;
    row-gap: 12px;
    margin-bottom: 24px;
`,O=l__default.default.div`
    max-height: 326px;
    overflow-y: auto;
    content-visibility: visible;
`,E=l__default.default.ul`
  margin-bottom: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    font-size: 0;

    & li a {
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    color: #717272;
    text-decoration: none;

    & li:first-child {
    margin-top: 4px;

    & li a:hover, & li a:focus, & li a:active {
    color: #717272;
}
}
}
`,P=l__default.default.ul`
  list-style: none;
  display: flex;
  column-gap: 20px;
  margin: 24px 0 24px 0;
  padding: 0;

  & li a {
    width: 24px;
    height: 24px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
}

& li a > img {
    width: 100%;
    height: auto;
    max-height: 24px;
}

`,M=l__default.default.div`
  display: flex;
  column-gap: 20px;
`,V=({data:o,onClickHandler:e})=>{let{title:p,links:s}=o||{};return t__default.default.createElement(t__default.default.Fragment,null,t__default.default.createElement(chunkWVST6R4U_js.a,{as:"h3",size:"300",fontWeight:"bold"},p),t__default.default.createElement(P,null,s.map(r=>t__default.default.createElement("li",{key:r.title},t__default.default.createElement("a",{onClick:()=>e(r.title),href:r.url},t__default.default.createElement("img",{src:r.image_url,alt:r.title}))))))},I=({data:o,onClickCallback:e,superHomePage:p})=>{let{links:s=[]}=o||{},r=n=>{switch(n){case"android_app":return "google play";case"iphone_app":return "app store";default:return ""}};return t__default.default.createElement(M,null,s.map(n=>t__default.default.createElement("a",{key:n.title,href:n.url,onClick:()=>e(r(n.title))},t__default.default.createElement("img",{src:n.image_url,alt:n.title,width:"136px",height:"40px"}))))},Z=({data:o,route:e,drivingWithBottomRoutes:p,showBottomNavbar:s,bottomSticky:r,driverIcon:n,eventActions:d,videoUrl:v})=>{let S=[o.useful_links,o.popular_search,o.other_geographies],{footerEvent:m=()=>{},appLinksClickEvent:b=()=>{}}=d||{},[x,k]=t.useState(),w=i=>{k(a=>a===i?"":i);},C=i=>{let{links:a=[],title:W}=i||{};return t__default.default.createElement(O,{$collapsed:W===x},t__default.default.createElement(E,null,!!a&&!!a.length&&a.map(u=>{let{title:c,value:K,url:B}=u||{};return t__default.default.createElement("li",{key:c},t__default.default.createElement("a",{onClick:()=>m(c,u),href:B},c))})))},_=(i,a)=>{if(a)switch(i){case"social_media":return t__default.default.createElement(V,{data:a,onClickHandler:m,key:i});case"app_links":return t__default.default.createElement(I,{data:a,onClickCallback:b,superHomePage:!0});case"cms_links":return null;default:return null}else return null};return t__default.default.createElement(t__default.default.Fragment,null,t__default.default.createElement($,null,t__default.default.createElement(j,null,(S||[]).map(i=>!!i&&t__default.default.createElement(chunk3WOKHVFK_js.b,{title:chunk3A5DQBXA_js.a((i.title||"").toLowerCase()),key:i.title,isOpen:i.title===x,onChange:w.bind(null,i.title)},C(i)))),t__default.default.createElement(A,{data:o,renderSections:_})),t__default.default.createElement(H,{routeName:e==null?void 0:e.name,drivingWithBottomRoutes:p,showBottomNavbar:s,bottomSticky:r,driver:n,videoUrl:v}))};

exports.a = Z;
